export const CONFIGURE_FILTERS = 'CONFIGURE_FILTERS';
export const REMOVE_FILTERS = 'REMOVE_FILTERS';
